import 'slick-carousel';
import 'slick-carousel/slick/slick.css'; // 追加
import 'slick-carousel/slick/slick-theme.css'; // 追加

$('.top-news-tab-list-item').on('click', function () {
  $('.top-news-tab-list-item').children('.top-news-tab-list-item-text.active').removeClass('active');
  $(this).children('.top-news-tab-list-item-text').addClass('active');
});
$(function () {

  // モーダルを取得
  const modal = document.getElementById("modal");
  // モーダルを表示するボタンを全て取得
  const openModalBtns = document.querySelectorAll(".js-open-modal");
  // モーダルを閉じるボタンを全て取得
  const closeModalBtns = document.querySelectorAll(".js-close-modal");

  // slickの設定
  if ($('.slick-wrapper').length > 0) {
    $(".slick-wrapper").slick({
      // autoplay:true,
      slidesToShow: 1,
      arrows: false,
      infinite: true,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });

    $('.p-works__modal__arrow--right').on('click', function () {
      $(".slick-wrapper").slick('slickNext');
    });

    $('.p-works__modal__arrow--left').on('click', function () {
      $(".slick-wrapper").slick('slickPrev');
    });

    // モーダルを表示するボタンをクリックしたとき
    openModalBtns.forEach((openModalBtn) => {
      openModalBtn.addEventListener("click", () => {
        // data-slide-indexに設定したスライド番号を取得
        const modalIndex = parseInt(openModalBtn.dataset.slideIndex) - 1;
        $('.slick-wrapper').slick("slickGoTo", modalIndex, false);
        modal.classList.add("is-active");
      });
    });
  }
  // モーダルを閉じるボタンをクリックしたとき
  closeModalBtns.forEach((closeModalBtn) => {
    closeModalBtn.addEventListener("click", () => {
      modal.classList.remove("is-active");
    });
  });

});

$("#prefectures").parent('span').addClass('prefectures-parent');

